// mutations.js
export default {
  openBottomCanvasCommit(state, payload) {
    state[payload.name] = payload.value;
  },
  setUser(state, user) {
    state.user = user;
  },
  setMfaStatus(state, status) {
    state.mfaEnabled = status;
  },
  showMfaWarningModal(state, status) {
    state.showMfaPrompt = status;
  },
  clearGlobalState(state) {
    state.user = null;
  },
  setProfilePhotoURL(state, url) {
    state.profilePhotoURL = url;
  },
  setAssessmentUserResponses(state, responses) {
    state.assessmentUserResponses = responses.map((x) => ({ ...x }));
  },
  setAssessmentReviewUserResponses(state, responses) {
    state.assessmentReviewUserResponses = responses.map((x) => ({ ...x }));
  },
  setSelectedOrg(state, selectedOrg) {
    state.selectedOrg = selectedOrg;
  },
  setCurrentSection(state, currentSection) {
    state.currentSection = currentSection;
  },
  setSelectedAssessment(state, selectedAssessment) {
    state.selectedAssessment = selectedAssessment;
  },
  setFilteredAssessments(state, filteredAssessments) {
    state.filteredAssessments = filteredAssessments;
  },
  setAssessments(state, assessments) {
    state.assessments = assessments;
  },
  setOrganisations(state, organisations) {
    state.organisations = organisations;
  },
  setQuestions(state, questions) {
    state.questions = questions;
  },
  setIsTrainingUser(state, isTrainingUser) {
    state.isTrainingUser = isTrainingUser;
  },
};
